module.exports = __webpack_public_path__ + "static/media/vlconsultingoffice.2225493b.pdf";